/**
 * @file index.tsx
 *
 * @fileoverview Renders the Webtrekk script in the page.
 */

import React, { useContext, useEffect } from 'react';
import Script from 'next/script';
import { PathContextInterface } from '~/jobiqo/models/app';
import { PathContext } from '~/jobiqo/context/app';
import { analyticsDispatchDelayed, EVENTS } from '~/jobiqo/lib/analytics';
import {
  getWebtrekkCustomCode,
  getWebtrekkPageViewDimensions,
} from '~/jobiqo/components/Slots/webtrekkCustomSlot';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export const Webtrekk = () => {
  const { user }: UserContextInterface = useContext(UserContext);
  const pathContext: PathContextInterface = useContext(PathContext);
  const { APP } = useFrontendConfig();
  const testing = process.env.testing;
  const staging = process.env.staging;

  // Log every page view to Webtrekk based on change of pathContext.path
  // and pathContext.querystring value. With this we can track also job detail
  // views on job search page.
  useEffect(() => {
    if (APP.WEBTREKK_ID && !testing && !staging) {
      analyticsDispatchDelayed(
        EVENTS.WEBTREKK_PAGE_VIEW,
        getWebtrekkPageViewDimensions(user, pathContext),
      );
    }
  }, [pathContext.path, pathContext.querystring]);

  const webtrekkCustomCode = getWebtrekkCustomCode();

  return APP.WEBTREKK_ID && !testing && !staging ? (
    <>
      <Script id="webtrekk-empty-container">{`window._ti = window._ti || {};`}</Script>
      <Script id="webtrekk-script">{`
        ${webtrekkCustomCode}

        window._tiConfig = window._tiConfig || {
        tiDomain: 'responder.wt-safetag.com',
        tiId: '${APP.WEBTREKK_ID}',
        option: {},
      };

        (function(a,d,c,f){a.wts = a.wts || [];var g=function(b){var a='';b.customDomain&&b.customPath?a=b.customDomain+'/'+b.customPath:b.tiDomain&&b.tiId&&(a=b.tiDomain+'/resp/api/get/'+b.tiId+'?url='+encodeURIComponent('https://'+d.location.host+'/')+'&v=5');if(b.option)for(var c in b.option)a+='&'+c+'='+encodeURIComponent(b.option[c]);return a};if(-1===d.cookie.indexOf('wt_r=1')){var e=d.getElementsByTagName(c)[0];c=d.createElement(c);c.async=!0;c.onload=function(){if('undefined'!==typeof a.wt_r&&!isNaN(a.wt_r)){var b=
        new Date,c=b.getTime()+1E3*parseInt(a.wt_r);b.setTime(c);d.cookie='wt_r=1;path=/;expires='+b.toUTCString()}};c.onerror=function(){'undefined'!==typeof a.wt_mcp_hide&&'function'===typeof a.wt_mcp_hide.show&&(a.wt_mcp_hide.show(),a.wt_mcp_hide.show=function(){})};c.src='//'+g(f);e.parentNode.insertBefore(c,e)}})(window,document,'script',_tiConfig);
      `}</Script>
    </>
  ) : null;
};

export default Webtrekk;
